import { render, staticRenderFns } from "./tab-rights.vue?vue&type=template&id=c85f8db2&"
import script from "./tab-rights.vue?vue&type=script&lang=js&"
export * from "./tab-rights.vue?vue&type=script&lang=js&"
import style0 from "./tab-rights.vue?vue&type=style&index=0&id=c85f8db2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports